module.exports = __webpack_public_path__ + "static/media/tte.1d35f5b6.mp3";